import callNative, { hasNativeBridge } from './callNative'

export { hasNativeBridge }


function transferSuccessToFunc(data) {
  for (let key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      if (typeof data[key] === 'object') {
        data[key] = transferSuccessToFunc(data[key])
      }
      if (
        key === 'success' &&
        !Object.prototype.hasOwnProperty.call(data, 'func')
      ) {
        data.func = data[key]
        delete data.success
      }
    }
  }
  return data
}

const native = {
  getUserToken() {
    return callNative.call('getToken')
  },
  /**
   * 设置title
  */
  setTitle(data = {}) {
    // 只在App环境下调用
    if (typeof window !== 'undefined' && hasNativeBridge()) {
      return callNative.call('setTitle', data)
    } else {
      // 浏览器环境直接跳过
      console.warn('[native.setTitle] skip in browser', data)
      return Promise.resolve()
    }
  },
  // 
  jumpPage(data = {}) {
    return callNative.call(data.pathName, data)
  },
  uploaderImgs(data = {}) {
    return callNative.call('uploaderImgs', data).then(res => {
      console.info('来自客户端choosePicOrAudioOrVideo返回的参数数据类型', typeof res)
      console.info('来自客户端choosePicOrAudioOrVideo返回的参数', res)
      return res
    })
  },
  jumpNavigation(data = {}) {
    return callNative.call('jumpNavigation', data)
  },
  /**
   * 关闭webView
  */
  closeWebView(data) {
    return callNative.call('closeWebView', data)
  },
  /**
   * 会话超时，请重新登录
  */
  sessionTimeout() {
    return callNative.call('sessionTimeout')
  },
  /**
   * 扫一扫
  */
  callScan() {
    return callNative.call('callScan')
  },
  /**
   * 唤起客户端设置页面
  */
  openSet() {
    return callNative.call('openSet')
  },
  /**
   * 新开webview
  */
  openNewWebView(data) {
    return callNative.call('openNewWebView', data)
  },
  /**
   * 获取学校列表
   * 返回 { name, lat, lon }
  */
  openSchoolList() {
    return callNative.call('openSchoolList').then(res => {
      if (typeof res == 'string') {
        return JSON.parse(res)
      } else {
        return res
      }
    })
  },
  /**
   * 选择图片或音视频
   *  type: img 图片 audio音频 video 视频
   *  isCompress: 0不压缩 1压缩
   *  len: 1 // 上传张数
   * 
   * res
   *  list: [ {
   *    src: xxx,
   *    name: 'xxx'
   * }]
  */
  choosePicOrAudioOrVideo(data = {}) {
    return callNative.call('choosePicOrAudioOrVideo', data).then(res => {
      console.info('来自客户端choosePicOrAudioOrVideo返回的参数数据类型', typeof res)
      console.info('来自客户端choosePicOrAudioOrVideo返回的参数', res)
      return res
    })
  },
  /**
   * 上传图片或音视频
   *  type: img 图片 audio音频 video 视频
   *  list
  */
  uploadFile(data = {}) {
    return callNative.call('uploadFile', data).then(res => {
      return JSON.parse(res)
    })
  },
  /**
   * 打开客户端功能页面
   * @param page 功能页面
   * @param param 传递的参数
   * 
  */
  callNativePage(data = {}) {
    console.info('打开客户端功能页面的上送', data)
    return callNative.call('callNativePage', data)
  },
  /**
   * 支付
  */
  callPay(data = {}) {
    return callNative.call('callPay', {
      from: 'order',
      ...data
    })
  },
  /**
   * 分享
   * @param  {
   *   title: 标题
   *   subTitle: 副标题
   *   url: 赛事详情链接
   * }
  */
  raceShare(data = {}) {
    callNative.notify('raceShare', data)
  }
}

export default native



// WEBPACK FOOTER //
// ./src/utils/jsbridge.js